import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class RouterHelper {
  constructor(public navCtrl: NavController) {}

  public async goToPortfolioPage() {
    return this.navCtrl.navigateRoot('/pages/portfolio');
  }
}
